const nodeListToArray = function(elements) {
  return Array.prototype.slice.call(elements);
}

const closeAllTabContents = function(tab) {
  const tabContents = nodeListToArray(tab.querySelectorAll('.tab-content'));
  for (const item of tabContents) {
    item.classList.remove('active');
  }
}

const initTermsAndConditionsModal = function() {
  const modal = document.getElementById('termsAndConditionsModal');
  const cb1 = document.querySelector("label[for='competitionTermsCheckbox1'] a");
  const cb2 = document.querySelector("label[for='competitionTermsCheckbox2'] a");
  modal.querySelector('.close').addEventListener('click', e => {
    modal.classList.remove('opened');
  });

  [cb1, cb2].forEach(link => {
    if (link) {
      link.addEventListener('click', (e) => {
        e.stopPropagation();
        modal.classList.add('opened');
      });
    }
  })
}

export const initTabs = function() {
  initTermsAndConditionsModal();
  const tabs = nodeListToArray(document.querySelectorAll('.tabs'));
  for (const tab of tabs) {
    const tabContents = nodeListToArray(tab.querySelectorAll('.tab-content'));
    const buttons = nodeListToArray(tab.querySelectorAll('button'));
    const buttonContainer = tab.querySelector('.buttons');
    const selectContainer = tab.querySelector('.select');
    const select = tab.querySelector('select');

    for (const item of buttons) {
      item.addEventListener('click', function(event) {
        closeAllTabContents(tab);
        const num = +event.target.getAttribute('data-action');
        buttons.forEach(btn => btn.classList.remove('selected'));
        const selectedTab = tabContents.filter(t => t.classList.contains('tab-content-' + num))[0]
        const hideTab = selectedTab.classList.contains('hide-tabs-when-selected');
        selectedTab.classList.add('active');
        event.target.classList.add('selected');
        if (hideTab) {
          buttonContainer.classList.add('hidden-tab-selector');
          selectContainer.classList.add('hidden-tab-selector');
        }
      })
    }

    select.addEventListener('change', function (event) {
      closeAllTabContents(tab);
      const num = +event.target.value;
      if (num) {
        const selectedTab = tabContents.filter(t => t.classList.contains('tab-content-' + num))[0]

        const redirect = event.target.selectedOptions[0].getAttribute('data-redirect');
        if(redirect)
        {
          window.location=redirect;
        }

        selectedTab.classList.add('active');
        const hideTab = selectedTab.classList.contains('hide-tabs-when-selected');
        if (hideTab) {
          buttonContainer.classList.add('hidden-tab-selector');
          selectContainer.classList.add('hidden-tab-selector');
        }
       
      }
    })
  }
}
